import { BufferedObservable } from '../tools/observable';
import { mockable } from '../tools/mockable';
import { trackRuntimeError } from './error/trackRuntimeError';
var BUFFER_LIMIT = 500;
export function startBufferingData() {
  var observable = new BufferedObservable(BUFFER_LIMIT);
  var runtimeErrorSubscription = mockable(trackRuntimeError)().subscribe(function (error) {
    observable.notify({
      type: 0 /* BufferedDataType.RUNTIME_ERROR */,
      error: error
    });
  });
  return {
    observable: observable,
    stop: function stop() {
      runtimeErrorSubscription.unsubscribe();
    }
  };
}